var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.elem.classes,attrs:{"title":_vm.elem.content}},[_c('i',{class:_vm.elem.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }